<template>
    <a-modal width="50%" title="完善资料" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
             :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose"
    >

        <a-form :model="form" :rules="rules" @submit="onSubmit"
                layout="vertical" ref="ruleForm">
            <a-row :gutter="[24, 8]">
                <a-col :span="24">
                    <a-form-item label="企业名称" name="companyName">
                        {{ form.companyName }}
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="营业执照正本原件照片(图片格式)" name="businessLicense">
                        <ImgDragUpload v-model:value="form.businessLicense"/>
                        <!-- <file-upload v-model:value="form.businessLicense" :size="800" :isPdfImg="true"  /> -->
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="营业执照副本原件照片(图片格式)" name="businessLicenseSide">
                        <ImgDragUpload v-model:value="form.businessLicenseSide"/>
                        <!-- <file-upload v-model:value="form.businessLicenseSide" :size="800" :isPdfImg="true"  /> -->
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="法人身份证正面照片(图片格式)" name="legalPersonCard">
                        <ImgDragUpload v-model:value="form.legalPersonCard"/>
                        <!-- <file-upload v-model:value="form.legalPersonCard" :size="800" :isPdfImg="true"  /> -->
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="法人身份证反面照片(图片格式)" name="legalPersonCardSide">
                        <ImgDragUpload v-model:value="form.legalPersonCardSide"/>
                        <!-- <file-upload v-model:value="form.legalPersonCardSide" :size="800" :isPdfImg="true"  /> -->
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item name="agentCardFile">
                        <template #label>
                            <div>
                                <div style="display: block;width:100%">
                                    经办人身份证正面照片(图片格式)
                                </div>
                                <div style="color: red; white-space: pre-line;">
                                    （法定代表人委托他人办理刻章备案登记，需上传该项资料）
                                </div>
                            </div>
                        </template>
                        <ImgDragUpload v-model:value="form.agentCardFile"/>
                        <!-- <file-upload v-model:value="form.agentCardFile" :size="800" :isPdfImg="true"  /> -->
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item name="agentCardFileSide">

                        <template #label>
                            <div>
                                <div style="display: block;width:100%">
                                    经办人身份证反面照片（图片格式）
                                </div>
                                <div style="color: red; white-space: pre-line;">
                                    （法定代表人委托他人办理刻章备案登记，需上传该项资料）
                                </div>
                            </div>
                        </template>
                        <ImgDragUpload v-model:value="form.agentCardFileSide"/>
                        <!-- <file-upload v-model:value="form.agentCardFileSide" :size="800" :isPdfImg="true"  /> -->
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="法人半身照（图片格式）" name="legalPersonPhoto">
                        <ImgDragUpload v-model:value="form.legalPersonPhoto"/>
                        <!-- <file-upload v-model:value="form.legalPersonPhoto" :size="800" :isPdfImg="true"  /> -->
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item name="agentPhoto">


                        <template #label>
                            <div>
                                <div style="display: block;width:100%">
                                    经办人半身照（图片格式）
                                </div>
                                <div style="color: red; white-space: pre-line;">
                                    （法定代表人委托他人办理刻章备案登记，需上传该项资料）
                                </div>
                            </div>
                        </template>
                        <ImgDragUpload v-model:value="form.agentPhoto"/>
                        <!-- <file-upload v-model:value="form.agentPhoto" :size="800" :isPdfImg="true"  /> -->
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="刻章备案登记表：经办人自备委托书由法人签字并按手印
                    或直接加盖法人章(PDF,图片格式)" name="registrationForm">

                        <file-upload style="float:left;
												width: 200px;
												height: 40px;margin-right:20px;" v-model:value="form.registrationForm"
                                     :size="800" :isPdfImg="true"/>
                        <a-button style="background: #a8a8a8;border:1px solid #a8a8a8" type="primary"
                                  @click="exportExcelTemplate1">
                            刻章备案登记表模板下载
                        </a-button>
                    </a-form-item>
                </a-col>
            </a-row>
        </a-form>

    </a-modal>
</template>

<script>
import {formMixin} from "@/mixins";
import {enterpriseEngraveApply} from "@/api/EnterpriseSealService";
// import ImgUpload from "@/components/form/upload/ImgUpload";
import ImgDragUpload from "@/components/form/upload/ImgDragUpload";
import dataCheck from "@/utils/dataCheck";
import axios from "axios";
import {notification} from "ant-design-vue";

export default {
    name: "ImproveModal",
    components: [ImgDragUpload],
    mixins: [formMixin],
    data() {
        return {
            submitUrl:enterpriseEngraveApply.saveOrUpdate,
            visible: false,
            form: {},
            rules: {
                id: [],
                companyName: [],
                agentIdCard: [dataCheck.required({}), dataCheck.id_num],
                businessLicense: [dataCheck.required({})],
                businessLicenseSide: [dataCheck.required({})],
                legalPersonCard: [dataCheck.required({})],
                legalPersonCardSide: [dataCheck.required({})],
                agentCardFile: [],
                agentCardFileSide: [],
                legalPersonPhoto: [dataCheck.required({})],
                agentPhoto: [],
                registrationForm: [dataCheck.required({})],

            }
        }
    },
    methods: {
        onClose() {
            this.visible = false
        },
        /*提交表单操作*/
        onSubmit() {
            if (!this.submitUrl) {
                this.$notification.warning({
                    message: '提示',
                    description: '请设置表单操作url地址',
                });
            } else {
                this.$refs.ruleForm
                    .validate()
                    .then(() => {
                        this.confirmLoading = true;
                        this.form.reason = ' ';
                        let params = this.transformParams
                            ? this.transformParams(this.form)
                            : this.form;
                        /*后台请求*/
                        this.getAxios('post',this.submitUrl,params, (res) => {
                            this.confirmLoading = false;
                            this.$notification.success({
                                message: '提示',
                                description: res.msg || '操作成功',
                            });

                            setTimeout(() => {
                                this.goMore('/EnterpriseSealService', this.form.companyCode ? this.form.companyCode : this.$route.query.id, 'list')
                            }, 500);
                            if (this.onSuccessFn) {
                                this.onSuccessFn(res);

                            }
                            if (this.isModal) {
                                this.$emit('finish');
                                this.onClose();
                            }
                        }).catch(() => {
                            this.confirmLoading = false;
                        })
                    })
                    .catch(error => {
                        if (error.errorFields.length) {
                            this.$notification.error({
                                message: '请检查必填项，必填项目不能不填',
                            });
                        }
                        window.console.log('error', error);
                    });
            }
        },
        getAxios(method, url, params, fun) {
            console.log(params.params)
            axios({
                method: method,
                headers: {
                    AuthenticationPhone: this.$ls.get('jwtphone'),
                    AuthenticationJwt: this.$ls.get('jwtMain')
                },
                url: url,
                data: {...params}
            }).then(res => {
                if(res.data.code==544){
                    notification.warning({
                        message: '登录过期',
                        style: {
                            width: '400px',
                            fontWeight: '600',
                            marginLeft: `${-200}%`,
                            marginTop: `${20}%`,
                        }
                    });
                    setTimeout(() => {
                        this.$router.push('/')
                    }, 50);
                }else{
                    if (res) {
                        fun(res)
                    }
                }
            })
        },
    }
}
</script>

<style scoped lang="less">
:deep(.img-upload) {
    width: 200px;
    height: 120px;
}

:deep(.ant-upload-list) {
    position: absolute;
    top: 0;
}

:deep(.ant-upload-list-picture-card-container) {
    width: 200px;
    height: 120px;
}

:deep(.ant-upload-list-item) {
    width: 200px;
    height: 120px;
}

:deep(.ant-table-scroll table) {
    min-height: 170px;
}
:deep(.ant-list-lg .ant-list-item) {
    padding: 16px 8px;
}
</style>
